export const CONSULTATION_TAB_OPTIONS = [
  { label: "Consultation", value: "consultation" },
  { label: "Referrals", value: "referrals" },
  { label: "Letters", value: "letters" },
  { label: "Prescriptions", value: "prescriptions" },
];
